// extracted by mini-css-extract-plugin
module.exports = {"btnLinkAuth":"styles_btnLinkAuth__31xld","authRow":"styles_authRow__2vFp3","authRowReset":"styles_authRowReset__3SoVu"};